export default {"src":"/_next/static/media/return.c0f6a465.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};